import { useEffect, useRef, useState } from 'react';

export function useVisibleImageLoader() {
  const elementRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target); // Stop observing once visible
            setIsVisible(true);
          }
        });
      },
      {
        rootMargin: '0px', // Adjust as needed to preload images slightly before they enter
        threshold: 0.1, // Percentage of element visible to trigger callback
      },
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, []); // Empty dependency array ensures this runs once on mount

  const loadImage = (src: string) => {
    if (!src) {
      setImageLoaded(true);
      return;
    }
    const img = new Image();
    img.addEventListener('error', () => {
      setImageLoaded(true);
    });
    img.addEventListener('load', () => {
      setImageLoaded(true);
    });
    img.src = src;
  }

  return {
    elementRef,
    isVisible,
    imageLoaded,
    setImageLoaded,
    loadImage,
  };
}